<template>
  <div id="app">
    <head>
      <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.13.0/css/all.css">
    </head>
    <Navbar @updateValue="updateValue" v-if="!isNotLogin && !isNotFound"></Navbar>
    <div class="dashboard" :class="{ 'login-pages': isNotLogin || isNotFound }">
      <section class="crancy-adashboard crancy-show" :class="{ 'crancy-close': closeMenu }">
        <router-view/>
      </section>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import {getCookie} from '@/assets/js/sharedFunctions';
import {mapActions} from "vuex";

export default {
  components: {
    Navbar,
  },
  data() {
    return {
      loc: "",
      closeMenu: false
    }
  },
  methods: {
    updateValue(newValue) {
      this.closeMenu = newValue;
    },
    ...mapActions(['fetchApiData']),
    ...mapActions(['fetchAlertsData']),
  },
  watch: {
    $route(to, from) {
      this.loc = window.location.pathname
      const cookie = getCookie('cn-token');
      if (cookie) {
        this.fetchApiData();
        this.fetchAlertsData();
      }
    }
  },
  mounted() {
    this.loc = window.location.pathname
    const languageCookie = getCookie("coinsnap-i18n")?.split(" expires")[0]?.replace(/\s+/g, '')
    if (languageCookie) this.language = languageCookie
    else {
      let expirationDate = new Date();
      expirationDate.setTime(expirationDate.getTime() + (365 * 24 * 60 * 60 * 1000));
      document.cookie = `coinsnap-i18n=en expires=${expirationDate.toUTCString()}; path=/`
    }
  },
  computed: {
    isNotLogin() {
      return (this.loc.includes("login") || this.loc.includes("verify") || this.loc.includes("register") || this.loc.includes("forgotpassword") || this.loc.includes("reset") || this.loc.includes("redoc"))
    },
    isNotFound() {
      return this.$route.matched.some(record => record.meta.notFound);
    }
  }
}
</script>
